import Vue from 'vue';
import { Validator } from 'vee-validate';
export default function () {
  this.staffBenefitValidation = function () {
    const dictonary = {
      custom: {
        planCode: {
          required: () => "Plan code is required"
        },
        dateEff: {
          required: () => "From is required"
        },
        dateExp: {
          required: () => "To is required"
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmploymentStaffBenefitsValidation.js